import { render, staticRenderFns } from "./PaidEventsConfigurationModal.vue?vue&type=template&id=7854b99a&scoped=true"
import script from "./PaidEventsConfigurationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaidEventsConfigurationModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PaidEventsConfigurationModal.vue?vue&type=style&index=0&id=7854b99a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7854b99a",
  null
  
)

export default component.exports